import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserTgProxyLink: Getter<UserState, RootState> = (state) => {
  if (!state.current?.tg_proxy_active) return ''

  return state.current?.tg_proxy_link || ''
}

export default getUserTgProxyLink
